import MediaInputGroup from './MediaInputGroup';
export default MediaInputGroup;
//# sourceMappingURL=index.js.mapimport MediaInputGroup from './MediaInputGroup';
export default MediaInputGroup;
//# sourceMappingURL=index.js.map